import clientInfo from 'common/lib/clientInfo';
import { useCallback } from 'react';
import { trackProductAnalytics } from 'common/services/product_analytics';

const useTrackOnOpen = () => {
  const trackCallback = useCallback(() => {
    trackProductAnalytics('Course Outline Generator Opened', {
      'Site ID': clientInfo.get('site_id'),
    });
  }, []);

  return trackCallback;
};

export default useTrackOnOpen;
